
export default {
  components: {},
  props: {
    visibleList: {
      type: Array,
      default: () => []
    },
    downloadList: {
      type: Array,
      default: () => []
    },
    topadshow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hrefLink: '',
      linkAddress: {},
      downmenu: [
        {
          logo: 'https://resources1.interface003.com/web20/img/head/android-icon.png',
          title: 'WikiFX安卓版', // 标题
          des: '全球监管查询APP',
          deskey: '22098',
          link: '', // 下载链接
          ewm: '',
          bj: 'wkfx',
          label: 'https://resources1.interface003.com/web20/img/head/android-ico.svg',
          show: true
        },
        {
          logo: 'https://resources1.interface003.com/web20/img/head/ios-icon.svg', // logo
          title: '', // 标题
          des: '全球监管查询APP',
          deskey: '22098',
          link: '', // 下载链接
          ewm: '',
          bj: 'jjb',
          label: 'https://resources1.interface003.com/web20/img/commen/ttt.svg',
          show: true
        },
        {
          logo: 'https://resources1.interface003.com/web20/img/head/windows-icon.png',
          title: 'PC Client',
          des: '全球监管查询桌面版',
          deskey: '23922',
          link: '',
          ewm: '',
          bj: 'whty', // 背景色
          label: 'https://resources1.interface003.com/web20/img/head/windows-ico.svg',
          show: true
        }
      ],
      menuList: [], // 菜单处理
      androidApk: null,
      iosUrl: null
    }
  },
  created() {
    // this.getDownloadList()
  },
  mounted() {
    this.setMenu()
    this.getDownloadList()
    // this.hrefLink = `${window.location.host}/${this.$store.state.LanguageCode}/donwload.html`
  },
  methods: {
    jumpLink(link) {
      if (link) {
        // console.log('123')
        location.href = link
      }
    },
    setMenu() {
      // 处理菜单item.code == 'menu_home'
      const menu = []
      this.visibleList.forEach((item) => {
        if (item.submenus.length > 0) this.menuList.push(item)
        else if (item.code != 'menu_home' && item.submenus.length == 0) {
          item.father = item.code
          menu.push(item)
        }
      })
      const arr = {
        code: 'menu_other',
        name: '其它',
        key: '20849',
        url: '/',
        submenus: [...menu]
      }

      this.menuList.push(arr)
      console.log(menu, 9999, arr, 888, this.menuList)
    },
    async getDownloadList() {
      await this.$api.download
        .homeClientInit()
        .then((res) => {
          res.forEach((el) => {
            if (el.Type == 1) {
              // 国内apk
              this.linkAddress.FXEYEapk = el.LinkAddress
            }
            if (el.Type == 2) {
              // 国外apk
              this.linkAddress.WikiFXapk = el.LinkAddress
            }
            if (el.Type == 3) {
              // ios国内
              this.linkAddress.fxeyeIOS = el.LinkAddress
            }
            if (el.Type == 4) {
              // ios 国外
              this.linkAddress.wikifxIOS = el.LinkAddress
            }
            if (el.Type == 5) {
              // 谷歌
              this.linkAddress.playGoogle = el.LinkAddress
            }
            if (el.Type == 6) {
              // pc
              this.linkAddress.fxeyePC = el.LinkAddress
            }
            if (el.Type == 7) {
              // *国内ios全球
              this.linkAddress.FXeye_golbal_ios = el.LinkAddress
            }
          })
          if (this.$store.state.isWiki == '1') {
            this.downmenu[0].title = 'WikiFX Android'
            this.downmenu[1].title = 'WikiFX IOS'
            this.androidApk = this.linkAddress.WikiFXapk
          } else if (this.$store.state.isWiki == '2' || this.$store.state.isWiki == '4') {
            this.androidApk = this.linkAddress.FXEYEapk
            this.downmenu[0].title = 'Fxeye Android'
            this.downmenu[1].title = 'Fxeye IOS'
          } else if (this.$store.state.isWiki == '3') {
            if (this.$store.state.myCountry.toLowerCase() == 'cn') {
              this.downmenu[0].title = 'Fxeye Android'
              this.downmenu[1].title = 'Fxeye IOS'
            } else {
              this.downmenu[0].title = 'WikiFX Android'
              this.downmenu[1].title = 'WikiFX IOS'
            }
            this.androidApk = this.linkAddress.FXEYEapk
          }
          this.downmenu[2].link = this.linkAddress.fxeyePC
          // this.downmenu[1].ewm = this.hrefLink
          // this.downmenu[2].ewm = this.hrefLink
        })
        .catch(() => {
          console.log('downloadInit,接口错误')
        })
    }
  }
}
